<template>
  <div class="pt-4">
    <h4 class="headerTitle mt-2">
      Registrador
    </h4>

    <div class="px-2 mt-2">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-5">
          <div class="form-group">
            <label class="label"
                   for="nomeDigitador">Nome do digitador</label>
            <select id="nomeDigitador"
                    v-model="registro.digitador"
                    :class="{ 'is-invalid': errors.has('nomeDigitador') }"
                    class="custom-select custom-select-sm"
                    name="nomeDigitador"
                    required
                    @change="changeData">
              <option :value="null">
                Selecione
              </option>
              <option v-for="(user, ind) in listUsers"
                      :key="ind"
                      :value="user.nome">
                {{ user.nome }}
              </option>
            </select>
            <small v-if="errors.has('nomeDigitador')"
                   class="invalid-feedback">{{ errors.first('nomeDigitador') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-5 col-md-4">
          <div class="form-group">
            <label class="label"
                   for="escrevente">Escrevente</label>
            <select id="escrevente"
                    v-model="registro.escrevente"
                    :class="{ 'is-invalid': errors.has('escrevente') }"
                    class="custom-select custom-select-sm"
                    name="escrevente"
                    :disabled="!escreventes.length"
                    @change="changeEscrevente">
              <option v-if="!escreventes.length"
                      value="">
                Selecione
              </option>
              <option v-for="(escrevente, ind) in escreventes"
                      :key="ind"
                      :value="escrevente.nome">
                {{ escrevente.nome }}
              </option>
            </select>
            <small v-if="errors.has('escrevente')"
                   class="invalid-feedback">{{ errors.first('escrevente') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-4 col-md-3 col-xl-2">
          <div class="form-group">
            <label class="label"
                   for="dataRegistro">Data do Registro</label>
            <input id="dataRegistro"
                   v-model="registro.data_registro"
                   v-mask="'##/##/####'"
                   v-validate="`required|date_format:dd/MM/yyyy|date_between:${initDate},${limitDate}`"
                   :class="{ 'is-invalid': errors.has('date') }"
                   class="form-control form-control-sm"
                   maxlength="10"
                   name="date"
                   placeholder="00/00/0000"
                   required
                   type="text"
                   @change="changeData">
            <small v-if="errors.has('date')"
                   class="invalid-feedback">{{ errors.first('date') }}</small>
          </div>
        </div>
      </div>
    </div>

    <h4 class="headerTitle mt-2">
      Registro
    </h4>

    <div class="px-2 mt-2">
      <div class="row">
        <div class="col-12 col-sm-2">
          <div class="form-group">
            <label class="label"
                   for="livroRegistro">Livro</label>
            <input id="livroRegistro"
                   ref="livroRegistro"
                   v-model="registro.livro"
                   v-validate="'required'"
                   :class="{ 'is-invalid': errors.has('livroRegistro') }"
                   class="form-control form-control-sm"
                   name="livroRegistro"
                   placeholder="00000"
                   type="number"
                   @change="changeData">
            <small v-if="errors.has('livroRegistro')"
                   class="invalid-feedback">
              {{ !registro.livro ? 'Campo obrigatório' : errors.has('livroRegistro') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-2">
          <div class="form-group">
            <label class="label"
                   for="folhaRegistro">Folha</label>
            <input id="folhaRegistro"
                   v-model="registro.folha"
                   v-validate="'required'"
                   :class="{ 'is-invalid': errors.has('folhaRegistro') }"
                   class="form-control form-control-sm"
                   name="folhaRegistro"
                   placeholder="000"
                   type="number"
                   required
                   @change="changeData">
            <small v-if="errors.has('folhaRegistro')"
                   class="invalid-feedback">
              {{ !registro.folha ? 'Campo obrigatório' : errors.has('folhaRegistro') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="termoRegistro">Registro</label>
            <input id="termoRegistro"
                   v-model="registro.termo"
                   v-validate="'required'"
                   :class="{ 'is-invalid': errors.has('termoRegistro') }"
                   class="form-control form-control-sm"
                   name="termoRegistro"
                   placeholder="0000000"
                   type="number"
                   required
                   @change="changeData">
            <small v-if="errors.has('termoRegistro')"
                   class="invalid-feedback">
              {{ !registro.termo ? 'Campo obrigatório' : errors.has('termoRegistro') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="ladoRegistro">Lado</label>
            <select id="ladoRegistro"
                    v-model="registro.lado"
                    class="custom-select custom-select-sm"
                    name="ladoRegistro"
                    @change="changeData">
              <option :value="`FRENTE`">
                Frente
              </option>
              <option :value="`VERSO`">
                Verso
              </option>
            </select>
          </div>
        </div>

        <div :class="'mt-lg-3 pt-lg-3'"
             class="col-auto">
          <div class="form-group pb-sm-1">
            <span class="custom-control custom-switch custom-control-inline">
              <input id="registros"
                     v-model="registro.dentro_prazo"
                     class="custom-control-input"
                     checked
                     name="registros"
                     type="checkbox"
                     @change="changeData"
                     @keyup.enter="changePrazo">
              <label class="custom-control-label"
                     for="registros">Registro no prazo</label>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* utils */
  import { document } from '@/utils/nascObject'

  /* constants */
  import objSwal from '@/constants/swalValues'

  /* services */
  import UsuarioService from '@/services/Auth/UsuarioService'

  /* others */
  import { mapGetters } from 'vuex'
  import moment from "moment"

  export default {
    name: 'RegistroLegado',
    inject: ['$validator'],
    props: {
      propCartorio: { type: Object, default: () => ({})},
      propRascunho: { type: Boolean, default: false }
    },
    data () {
      return {
        document,
        dataObj: {},
        registro: {
          oficial: '',
          digitador: '',
          escrevente: '',
          dentro_prazo: true,
          data_registro: '',
          lado: 'FRENTE',
          origem: 'legado',
          cargo_escrevente: ''
        },
        escreventes: [],
        sequenciaLivro: {},
        localData: {},
        listUsers: [],
        initDate: '01/01/1500',
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorioId: 'auth/getCartorioId',
      })
    },
    watch: {
      propCartorio () {
        if (this.propCartorio.nome_oficial) {
          this.registro.oficial = this.propCartorio.nome_oficial
        }
        if (!!this.propCartorio.pessoa) {
          this.registro = {...this.propCartorio}
          this.registro.data_registro = this.propCartorio.data_registro ? moment(this.propCartorio.data_registro, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
          this.init()
        }
      }
    },
    mounted () {
      this.getUsersList()
      if (!!this.propCartorio.pessoa) {
        this.registro = {...this.propCartorio}
        this.registro.data_registro = moment(this.registro.data_registro, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      this.init()
    },
    methods: {
      init () {
        if (!this.propCartorio.pessoa) {
          this.registro.data_registro = moment(new Date()).add('day').format('DD/MM/YYYY')
          this.registro.escrevente = this.user.nome
          this.registro.digitador = this.user.nome
          this.changeData()
        }

        if (!!this.propCartorio.pessoa) {
          this.initDate = moment(this.propCartorio.pessoa.data_nascimento).add(-1, 'day').format('DD/MM/YYYY')
        }
      },
      async getUsersList () {
        try {
          await UsuarioService.getUsuarios().then(res => { this.listUsers = res.data })
        } catch (e) {
          return this.getAnError(e)
        }
        await this.loadEscreventes()
      },
      async loadEscreventes () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        let usuarios = response.data || []
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )
      },
      changeData () {
        return this.$emit('receiveData', this.mountObj())
      },
      mountObj () {
        return {
          registro: {
            ...this.document.registro,
            ...this.registro,
            rascunho_id: this.$route.params.idNasc,
            digitador: this.registro.digitador,
            escrevente: this.registro.escrevente,
            data_registro: moment((this.registro.data_registro ? this.registro.data_registro : new Date()), 'DD/MM/YYYY').format('YYYY-MM-DD'),
            primeiraVia: 'legado',
            tipo_registro: 'N',
            num_livro: this.registro.livro,
            folha: this.registro.folha,
            termo: this.registro.termo
          },
        }
      },
      getAnError (text) {
        loader({ text: '', active: false })

        objSwal.error.title = 'Erro ao cadastrar'
        objSwal.error.text = text || 'Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte'
        return Swal.fire(objSwal.error)
      },
      changePrazo () {
        setTimeout(() => {
          this.registro.dentro_prazo = !this.registro.dentro_prazo

          this.changeData()
        }, 200)
      },
      changeEscrevente () {
        if (this.registro.escrevente) {
          const selectEscreventes = window.document.getElementById('escrevente')
          this.registro.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex].cargo
        }
        this.changeData()
      }
    },
  }
</script>

<style lang="scss">
@import '../../../../scss/_utilities/_exports';

.headerTitle {
  @extend %titleBox--sm;
  background-color: $color-gray-light;
}
</style>
